import React, { useEffect, useState } from "react"
import defaultStyle from "../../../styles/defaultPageStyle.module.css"
import List from "../../../components/List/List"
import { EEnableStatusType } from "../../../Enum/EEnableStatusType"
import { noticeMemory } from "../../../Objects/Memory/Memory"
import { NoticeEntity } from "../../../Objects/Notice/NoticeEntity"
import { useGetNotice } from "../../../hooks/Notice/useGetNotice"
import { NoticePopup } from "./NoticePopup"
import { useOnboardingCreatePopup } from "../../../hooks/useOnboardingCreatePopup"
import { useTranslation } from "react-i18next"
import { ImportDataPopup } from "../../../components/DataImport/ImportDataPopup"

export const NoticesPage: React.FC = () => {
  const { t } = useTranslation(["notice", "list", "dataImport"])

  const { handleGetNotice } = useGetNotice()

  const [notice, setNotice] = useState<NoticeEntity | undefined>(undefined)

  const [enableNotices, setEnableNotices] = useState(false)

  const [enableImport, setEnableImport] = useState(false)

  useEffect(() => {
    handleGetNotice(() => {})
  }, [])

  const handleSwitch = (status: boolean) => {
    setEnableNotices(status)

    setNotice(undefined)
  }

  useOnboardingCreatePopup(() => handleSwitch(true))

  const handleCopyNotice = () => {
    if (!notice) {
      return
    }

    setNotice(new NoticeEntity({ ...notice, id: -1, iconUrl: "" }))
  }

  return (
    <>
      <div className={defaultStyle.containerList}>
        <List
          enableLocalPagination
          messageCount={t("list:label_notices_page_message_count")}
          messageEmpty={t("list:label_notices_page_message_empty")}
          nameFindSearch={t("list:label_notices_page_place_holder")}
          data={noticeMemory.getListCards(true)}
          nameDropdown={Object.mapEnumToStrings(EEnableStatusType)}
          handleAddButton={() => handleSwitch(true)}
          handleImportFloatButton={() => setEnableImport(true)}
          handleRefreshButton={() => handleGetNotice(() => {})}
          handleOnClick={(id) => {
            setNotice(noticeMemory.findById(id) || undefined)
            setEnableNotices(true)
          }}
        />
      </div>

      {enableNotices && (
        <NoticePopup
          title={notice && notice.id !== -1 ? t("title_popup_edite") : t("title_popup_create")}
          notice={notice}
          onClose={() => handleSwitch(false)}
          onCopy={handleCopyNotice}
        />
      )}

      {enableImport && (
        <ImportDataPopup
          target="avisos"
          title={t("dataImport:title", { target: t("dataImport:target_notices") })}
          onClose={() => setEnableImport(false)}
          onImported={() => handleGetNotice(() => {})}
        />
      )}
    </>
  )
}
